import React from 'react';
import { TextButton } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './styles';

interface Props {
  elementId: string;
  isExpanded: boolean;
  toggleExpanded: VoidFunction;
}

export const ExpandableContentToggleButton = ({ isExpanded, toggleExpanded, elementId }: Props) => (
  <TextButton
    css={styles.btnToggleExpanded}
    onClick={(evt) => {
      evt.stopPropagation();
      toggleExpanded();
    }}
    aria-expanded={isExpanded}
    aria-controls={elementId}
  >
    Show {isExpanded ? 'less' : 'all'}
  </TextButton>
);
